import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Component, Inject, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, Scroll } from '@angular/router';
import { AvailableDrupalVersions, DrupalVersion, IIndividual, INDIVIDUAL } from 'pac-api';
import { BehaviorSubject, noop, Subject } from 'rxjs';
import { delay, filter, take } from 'rxjs/operators';
import { SubSink } from 'subsink';

import { Individual } from './model/individual';
import { WizardService } from './wizard/wizard.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {

  static readonly Name = 'AppComponent';
  readonly Name = 'AppComponent';

  public title = 'Signup Wizard';

  private busy = false;

  public get Busy(): boolean {
    return this.busy;
  }
  
  public Loading$: Subject<boolean> = new BehaviorSubject(true);

  private subsink = new SubSink();

  constructor(
    public wizard: WizardService,
    private router: Router,
    private viewportScroller: ViewportScroller,
    private renderer: Renderer2,
    private zone: NgZone,
    @Inject(DOCUMENT) private doc: Document,
    @Inject(INDIVIDUAL) private individual: IIndividual,
    @Inject(DrupalVersion) private drupalVer: AvailableDrupalVersions,
  ) {
    this.wizard.Ping().subscribe(noop);

    this.subsink.sink = this.router.events.subscribe(event => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.Loading$.next(true);
          break;
        }
        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.Loading$.next(false);
          break;
        }
      }
    });
  }

  public ngOnInit(): void {

    if (this.individual) {
      const individual = new Individual(this.individual);
      this.wizard.setIndiviudal(individual);
    }

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.wait(false);
    });

    this.router.events.pipe(filter(event => event instanceof Scroll)).subscribe(() => {
      this.zone.onStable.pipe(
        take(1),
        delay(100),
      ).subscribe(() => {
        if (this.drupalVer == 'd7') {
          this.viewportScroller.scrollToAnchor('app-component-top')
        } else {
          // Scroll to first H1 on the page
          this.doc.querySelector('h1').scrollIntoView(true);
        }
        
      });
    });
  }

  public wait(state = true) {
    this.busy = state;

    if (state) {
      this.renderer.addClass(this.doc.body, 'wait');
    } else {
      this.renderer.removeClass(this.doc.body, 'wait');
    }
  }

  public ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }
  
  public scrollUp();
  public scrollUp(element: Element);
  public scrollUp(anchor: string);
  public scrollUp(scrollTo: string | Element = undefined): void {
    if (scrollTo === undefined) {
      if (this.drupalVer == 'd7') {
        scrollTo = 'app-component-top';
      } else {
        // Scroll to first H1 on the page
        scrollTo = this.doc.querySelector('h1');
      }
    }
    if (typeof(scrollTo) === 'string') {
      this.viewportScroller.scrollToAnchor(scrollTo);
    } else if (scrollTo instanceof Element) {
      scrollTo.scrollIntoView(true);
    }
  }
}
